import { findDefinitionPartById, isGroup, recursiveFilter, isCountGroup } from './mutations'
import definitionSerializer from '../services/serializer'

const MAX_NESTING_LEVEL = 2

export default {
  canNotUndo: (state, getters) => getters['undoHistory/canNotUndo'],
  canNotRedo: (state, getters) => getters['undoHistory/canNotRedo'],
  getDefinition: state => state.definition.children,
  aDefinition: state => state.definition,
  selected: state => state.selected,
  targetDefinitionLastAttributeCommand: state => state.lastAttributeCommand,
  selectedCount: state => state.selected.length,
  hasDefinition: state => state.definition.children.length > 0,
  serializedDefinition: state => definitionSerializer.serialize(state.definition),
  lastTimeTargetWasChanged: state => state.lastTimeTargetWasChanged,
  selectedCanBeGrouped: (state, getters) => {
    return (
      getters.hasDefinition &&
      getters.selectedCount > 1 &&
      findMaxDepth(state.definition.children, state.selected[0]) + Math.max(...state.selected.map(selected => getDepthCount(findDefinitionPartById(state.definition, selected)))) < MAX_NESTING_LEVEL
    )
  },
  selectedCanBeUngrouped: (state, getters) => {
    return getters.hasDefinition && getters.selectedCount > 0 && state.selected.every(selectedId => isGroup(findDefinitionPartById(state.definition, selectedId)))
  },
  selectedCanBecomeCountGroup: (state, getters) => {
    return getters.hasDefinition && getters.selectedCount === 1 && state.selected.every(selectedId => isGroup(findDefinitionPartById(state.definition, selectedId)))
  },
  selectedCanBeDeleted: (state, getters) => getters.hasDefinition && getters.selectedCount > 0,
  isAttributeSelected: (state, getters) => attr => {
    return state.selected.some(selectedId => attr.definitionId === selectedId) || getters.isAttributeInSelectedGroup(attr)
  },
  isAttributeInSelectedGroup: (state, getters) => attr => {
    return state.selected
      .filter(selected => isGroup(getters.getDefinitionPartById(selected)))
      .map(getters.getDefinitionPartById)
      .some(group => findDefinitionPartById(group, attr.definitionId))
  },
  isTargetEditable: state => !state.viewOnly,
  getDefinitionPartById: state => id => findDefinitionPartById(state.definition, id),
  canDraggingItemDropHere: (state, getters) => (id, depth) => {
    const draggingItemId = state.dragAndDrop.draggingItem
    // if dragging item is the same as this current definiton part return false
    if (draggingItemId === id) {
      return false
    }
    const draggingItem = findDefinitionPartById(state.definition, draggingItemId)
    const dropArea = findDefinitionPartById(state.definition, id)
    // if draggingItem is a group it can not drop in at the max level
    if ((isGroup(draggingItem) && depth === MAX_NESTING_LEVEL) || isCountGroup(dropArea) || getters.isInACountGroup(id)) return false

    // is this is in the current dragging item group then return false
    if (isGroup(draggingItem)) {
      const isInCurrentDraggingGroup = recursiveFilter(draggingItem, def => def.definitionId === id).length > 0
      if (isInCurrentDraggingGroup) return false
    }
    return true
  },
  disableDefinitionPart: (state, getters) => id => {
    // check to see if the target definition is editable at all
    if (!getters.isTargetEditable) return true
    return false
  },
  isDragAndDropActive: state => state.dragAndDrop.active,
  isDraggingPart: state => !!state.dragAndDrop.draggingItem,
  selectedAttributes: state => {
    if (state.selected.length > 0) {
      return [...state.selected].map(partId => findDefinitionPartById(state.definition, partId))
    }
    return []
  },
  isInACountGroup: (state, getters) => id => {
    return (
      recursiveFilter(state.definition, part => {
        let found = false
        if (isCountGroup(part)) {
          found = part.children.find(child => child.definitionId === id)
        }
        return found
      }).length > 0
    )
  },
  updateLasTD: state => {
    return state.updateLasTD
  },
}

// How deep do I go?
function getDepthCount (node) {
  return !(node && node.children) ? 0 : Math.max(...node.children.map(child => getDepthCount(child))) + 1
}

// How deep am I?
function findMaxDepth (definition, definitionId, startingDepth = 0) {
  for (let i = 0; i < definition.length; i++) {
    if (definition[i].definitionId === definitionId) {
      return startingDepth
    }
    if (definition[i].children) {
      const foundDepth = findMaxDepth(definition[i].children, definitionId, startingDepth + 1)
      if (foundDepth > -1) return foundDepth
    }
  }
  return -1
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/targetDefinition/store/getters.js